import React from "react";
import { EyebrowText } from "../../atoms/EyebrowText";
import "./styles.css";

/**
 * Sección "Nuestras marcas" para la home.
 * Fondo navy completo, eyebrow naranja + heading blanco, logos monocromáticos
 * en blanco con carrusel infinito (mismo comportamiento que ya tenía).
 */
export const BrandsAndTestimonials = () => {
  const brands = [
    { src: "./images/marcas/victory.png", alt: "Victory" },
    { src: "./images/marcas/honda.png", alt: "Honda" },
    { src: "./images/marcas/bajac.png", alt: "Bajaj" },
    { src: "./images/marcas/yamaha.png", alt: "Yamaha" },
    { src: "./images/marcas/tvs.png", alt: "TVS" },
    { src: "./images/marcas/akt.png", alt: "AKT" },
    { src: "./images/marcas/hero.png", alt: "Hero" },
    { src: "./images/marcas/zuzuki.png", alt: "Suzuki" },
    { src: "./images/marcas/kawasaki.png", alt: "Kawasaki" },
    { src: "./images/marcas/ktm.png", alt: "KTM" },
    { src: "./images/marcas/kymco.png", alt: "Kymco" },
  ];

  // Duplicamos la lista para que el carrusel infinito no muestre cortes.
  const trackBrands = [...brands, ...brands, ...brands];

  return (
    <section className="brands-section" aria-labelledby="brands-title">
      <div className="brands-section__inner">
        <EyebrowText className="brands-section__eyebrow">
          Aliados de confianza
        </EyebrowText>
        <h2 id="brands-title" className="brands-section__heading">
          Nuestras marcas
        </h2>
      </div>

      {/* Slider full-bleed: vive fuera del inner para abarcar todo el viewport */}
      <div className="brands-slider" aria-hidden="false">
        <div className="brands-track">
          {trackBrands.map((brand, index) => (
            <img
              key={`${brand.alt}-${index}`}
              src={brand.src}
              alt={brand.alt}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
